import chirotouchIcon from 'assets/chirotouch-icon.png'
import styled from 'styled-components'

const ChirotouchIcon = styled.img.attrs(() => ({
  src: chirotouchIcon,
  alt: 'chirotouch icon',
}))`
  width: 25px;
  position: relative;
  top: 8px;
  margin-left: 3px;
`

export default ChirotouchIcon
